import useJobCategoryStore from '../store/store.jobCategory'
import { TJobCategory } from '../type/jobCategoryStoreType'

const useRightSection = () => {
  const jobCategoryStore = useJobCategoryStore()
  const categories = jobCategoryStore.categories
  const activeIds = jobCategoryStore.activeIds
  const idsByDepth = jobCategoryStore.idsByDepth

  const getCategoriesByIds = jobCategoryStore.getCategoriesByIds
  const activeId = jobCategoryStore.activeId
  const selectId = jobCategoryStore.selectId
  const unSelectId = jobCategoryStore.unSelectId
  const unSelectIdWithChildren = jobCategoryStore.unSelectIdWithChildren
  const idIsShowSelected = jobCategoryStore.idIsShowSelected

  const isSecondDepth = activeIds.length < 2

  const allTargetCategory = (() => {
    const targetId = isSecondDepth ? activeIds?.[0] : activeIds?.[1]
    if (!targetId) {
      return null
    }
    const result = categories[targetId]

    return result
  })()

  const isAllChecked =
    allTargetCategory &&
    idIsShowSelected(allTargetCategory.id) &&
    allTargetCategory.selectedChildrenIds.length === 0

  const rightSectionItem = (() => {
    const isNotActiveIds = activeIds.length === 0

    if (isNotActiveIds) {
      return []
    }

    const idsDepthCursor = isSecondDepth ? 2 : 3
    const resultIds = idsByDepth?.[idsDepthCursor]

    const activeIdDepth = isSecondDepth ? 0 : 1
    const result = getCategoriesByIds(resultIds).filter((category) => {
      return category.parentId === activeIds?.[activeIdDepth]
    })

    return result
  })()

  const handleItemClick = (category: TJobCategory) => {
    const { id, isSelect } = category
    if (!isSecondDepth && isSelect) {
      return unSelectId(id)
    }

    const isParentSelect =
      allTargetCategory && idIsShowSelected(allTargetCategory.id)
    if (!isSecondDepth && isParentSelect && allTargetCategory) {
      unSelectId(allTargetCategory.id)
    }

    selectId(id)
    if (isSecondDepth) {
      activeId(id)
    }
  }

  const handleAllClick = () => {
    if (!allTargetCategory) {
      return
    }
    if (isAllChecked) {
      return unSelectId(allTargetCategory.id)
    }

    unSelectIdWithChildren(allTargetCategory.id)
    selectId(allTargetCategory.id)
  }

  return {
    isSecondDepth,
    allTargetCategory,
    isAllChecked,
    rightSectionItem,
    onItemClick: handleItemClick,
    onAllClick: handleAllClick,
  }
}

export default useRightSection
